const EQUIPMENT_STATUS_ON = 'EQUIPMENT_STATUS_ON';
const EQUIPMENT_STATUS_OFF = 'EQUIPMENT_STATUS_OFF';
const EQUIPMENT_STATUS_STANDBY = 'EQUIPMENT_STATUS_STANDBY';
export const equipmentStatus = {
    on: EQUIPMENT_STATUS_ON,
    off: EQUIPMENT_STATUS_OFF,
    standby: EQUIPMENT_STATUS_STANDBY,
};
export const equipmentStatusToName = {
    [EQUIPMENT_STATUS_ON]: 'on',
    [EQUIPMENT_STATUS_OFF]: 'off',
    [EQUIPMENT_STATUS_STANDBY]: 'standby',
};
